import { Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import Skeleton from "@saleor/components/Skeleton";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

import { getStringOrPlaceholder, maybe, renderCollection } from "../../../misc";
// import { ListProps } from "../../../types";
import { SaleDetails_sale_tenants_edges_node } from "../../types/SaleDetails";

export interface StoreListProps {
  stores: SaleDetails_sale_tenants_edges_node[];
  disabled: boolean;
  emptyText: React.ReactNode;
  title: React.ReactNode;
  onStoreAssign: () => void;
  onStoreUnassign?: (store: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonDisabled: {
      "& > span": {
        color: "#616161"
      }
    },
    iconCell: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 48 + theme.spacing(2)
    },
    indicator: {
      color: theme.palette.text.disabled,
      display: "inline-block",
      left: 0,
      marginRight: theme.spacing(0.5),
      position: "absolute"
    },
    offsetCell: {
      "&:first-child": {
        paddingLeft: theme.spacing(3)
      },
      position: "relative"
    },
    pointer: {
      cursor: "pointer"
    },
    root: {
      "&:last-child": {
        paddingBottom: 0
      },
      paddingTop: 0
    },
    rotate: {
      transform: "rotate(180deg)"
    },
    textRight: {
      textAlign: "right"
    },
    toLeft: {
      "&:first-child": {
        paddingLeft: 0
      }
    },
    wideColumn: {
      width: "100%"
    }
  }),
  { name: "SalesStoreList" }
);

const SalesStoreList: React.FC<StoreListProps> = props => {
  const {
    stores,
    disabled,
    emptyText,
    title,
    onStoreAssign,
    onStoreUnassign
  } = props;
  const classes = useStyles(props);

  const [isCollapsed, setCollapseStatus] = React.useState(true);
  const toggleCollapse = () => setCollapseStatus(!isCollapsed);

  return (
    <Card>
      <CardTitle
        title={title}
        toolbar={
          <Button
            id="assignStoresBtn"
            color="primary"
            disabled={disabled}
            className={disabled ? classes.buttonDisabled : null}
            onClick={onStoreAssign}
          >
            <FormattedMessage
              defaultMessage="Assign Stores"
              description="button"
            />
          </Button>
        }
      />
      <CardContent className={classes.root}>
        <Table>
          <TableBody>
            <TableRow className={classes.pointer} onClick={toggleCollapse}>
              <TableCell
                className={classNames(classes.wideColumn, classes.toLeft)}
                id="numStoresBtn"
              >
                <FormattedMessage
                  defaultMessage="{number} Stores"
                  description="number of stores"
                  values={{
                    number: getStringOrPlaceholder(stores?.length.toString())
                  }}
                />
              </TableCell>
              <TableCell
                className={classNames(classes.textRight, classes.iconCell)}
              >
                <IconButton>
                  <ArrowDropDownIcon
                    id="arrowDropDownBtn"
                    className={classNames({
                      [classes.rotate]: !isCollapsed
                    })}
                  />
                </IconButton>
              </TableCell>
            </TableRow>
            {!isCollapsed &&
              renderCollection(
                stores,
                (store, index) => (
                  <TableRow key={store ? store.id : "skeleton"}>
                    <TableCell
                      className={classes.offsetCell}
                      id={`storeNameRow${index}`}
                    >
                      {maybe<React.ReactNode>(
                        () => (
                          <>{store.storeName}</>
                        ),
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell
                      className={classNames(
                        classes.textRight,
                        classes.iconCell
                      )}
                    >
                      <IconButton
                        id={`storeDeleteBtnRow${index}`}
                        color="primary"
                        disabled={!store || disabled}
                        onClick={() => onStoreUnassign(store.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ),
                () => (
                  <TableRow>
                    <TableCell className={classes.toLeft} colSpan={2}>
                      {emptyText}
                    </TableCell>
                  </TableRow>
                )
              )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
export default SalesStoreList;
